module.exports = __webpack_public_path__ + "static/media/AngelsOfAether_Race_07.1695b797.jpg";